import axios from 'axios';
import { API_COMM_UPLOAD } from "@/constant/api";
import store from '@/store'
import {Message} from 'view-design'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import baseUrl from "@/utils/url";
import {getToken} from "@/utils/token";
// axios 跨域请求携带 cookie
axios.defaults.withCredentials = false
// axios.defaults.xsrfCookieName = 'xsrf-token' //当创建实例的时候配置默认配置

const DEFAULT_CONFIG = {
    method: 'GET',
    // host:process.env.API_HOST,
    // host: process.env.API_HOST,
    // protocol: process.env.API_PROTOCOL,
    // baseUrl: process.env.API_HOST,
    // host:process.env.API_HOST,
    timeout: 30000,
    loading: false,
    errorType: 'notification',
    checkStatus: true,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
}

// 默认传递的参数
const DEFAULT_PARAMS = {}



// const errorAction = (err, sendData, options)=>{
//
// }

/**
 * 发起一个请求
 * @param apiPath
 * @param params
 * @param optionsSource
 */
export default async function request(apiPath, params = {}, optionsSource = {}) {
    const options = Object.assign({}, DEFAULT_CONFIG, optionsSource)
    const { method, responseType, formData } = options
    let { headers } = options
    console.log(apiPath)
    if (apiPath) {
        if (!['/login', '/captcha','/register'].some((e) => apiPath.indexOf(e) >= 0)) {
            const token = getToken()
            // if(token){
            // }else {
            //     await store.dispatch('logout')
            //     return Promise.reject({
            //         message:'获取token失败'
            //     })
            // }
            headers['Authorization'] = token || '';
        }
    }
    if(apiPath === API_COMM_UPLOAD){
        headers['Content-type'] = 'multipart/form-data'
    }else {
        headers['Content-type'] = 'application/json;charset=UTF-8'
    }
    const sendData = {
        // url: `${protocol}${path.join(host || '', baseUrl || '', apiPath || '')}`,
        url:baseUrl+apiPath,
        method,
        responseType,
        headers
    }
    // console.log(sendData.url)

    const paramsData = Object.assign({}, DEFAULT_PARAMS, params)

    if (method === 'GET') {
        sendData.params = params
    } else if (formData) {
        const formData = new FormData()
        Object.keys(paramsData).forEach(key => {
            formData.append(key, paramsData[key])
        })
        sendData.data = formData
    } else {
        sendData.data = paramsData
    }

    return new Promise(async (resolve, reject) => {
      NProgress.start()
      axios(sendData)
        .then(async (response) => {
          NProgress.done()
          const { status } = response;
          if (status !== 200) {
            // Message.error({
            //   background: true,
            //   content: '网络异常，请稍后重试'
            // });
            //   Message.error({
            //       background: true,
            //       content:response.data?response.data.message : '网络异常，请稍后重试'
            //   });
            return reject(new Error(response.data.message));
          }
          const { code, data, message } = response.data;
          // console.log('message',message)
          switch (code) {
            case 1000:
             return resolve(data);
            case 999:
              Message.error({
                background: true,
                content: '您无权限，请使用授权账号登录'
              });
              await store.dispatch('logout')
              break;
              // return Promise.reject({
              //   message:'获取token失败'
              // })
              case 998:
                  store.commit('SET_USERDOWN_STRFILE',data.parent_strfile)
                  store.commit('SET_NEWGROUP_MODAL_Visible',true)
                  Message.info({
                      background: true,
                      content: message
                  });
                  return reject({
                      code,
                      message
                  });
            default:
                Message.error({
                    background: true,
                    content: message
                });
              return reject({
                code,
                message
              });
          }
        })
        .catch(async err => {
          NProgress.done()
          console.log('err',err)
          Message.error({
            background: true,
            // content: '网络异常，请稍后重试'
           content:JSON.stringify(err),
            // duration:9999999
          });
          // await errorAction(err, sendData, options)
          // return Promise.reject({  path: apiPath, sendData, resData: err })
          reject(err)
        })
    })
}




// WEBPACK FOOTER //
// ./src/utils/request.js